import { Backdrop, Button, Paper, styled } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import { useDispatch } from "react-redux";

import { reportGifById } from "store/video/video-action";
import cross from "components/icons/cross-black.svg";

import ReportStepOne from "./ReportStepOne";
import ReportStepTwo from "./ReportStepTwo";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  gifId: string;
  handleMainPopup: () => void;
}

export interface IReason {
  value: number;
  text: string;
}

const REPORT_REASONS: IReason[] = [
  { value: 0, text: "Underaged / people" },
  { value: 1, text: "Racist/offensive language/acts" },
  { value: 2, text: "Animals/acts of Bestiality" },
  { value: 3, text: "Rape/Sexual assault" },
  { value: 4, text: "Violence/Death/Disturbing" },
  { value: 5, text: "Copyright / I own this content" },
  { value: 6, text: "I am in this GIF" },
  { value: 7, text: "Other" },
];

const ReportPopup = (props: IProps) => {
  const { isOpen, togglePopup, gifId, handleMainPopup } = props;

  const dispatch = useDispatch();

  const [reportReason, setReportReason] = useState<IReason>(REPORT_REASONS[0]);
  const [reportMessage, setReportMessage] = useState<string>("");
  const [isCanContact, setIsCanContact] = useState<boolean>(false);

  const handleReportMessage = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setReportMessage(event.target.value);
  };

  const handleIsCanContact = () => {
    setIsCanContact(!isCanContact);
  };

  const [currentStep, setCurrentStep] = useState<number>(0);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleToogle = () => {
    setCurrentStep(0);
    setReportMessage("");
    setReportReason(REPORT_REASONS[0]);
    setIsCanContact(false);
    togglePopup();
    handleMainPopup();
  };

  const report = () => {
    dispatch(reportGifById({
      gifId: gifId,
      option: reportReason.value,
      message: reportMessage,
      canContact: isCanContact,
      email: ""
    }));
    handleToogle();
  };

  const stopBackdropPropagation = (event: React.MouseEvent) => event.stopPropagation();

  return (
    <Backdrop open={isOpen} id={"add-to-collection-popupOpen"}
      sx={{
        zIndex: 100
      }}
      onClick={stopBackdropPropagation}
    >
      <Paper
        sx={{
          width: "420px",
          overflowY: "auto",
          padding: "24px 30px 0 30px",
          borderRadius: "24px",
          zIndex: 22,
          margin: "0 16px",
          "@media and (max-width: 767px)": {
            width: "90wv",
            maxHeight: "95vh",
            minHeight: "70vh",
          }
        }}>
        <PopupSubheader >
          <h3>Report GIF</h3>
          <Button onClick={handleToogle}><img src={cross} alt="close popup" /></Button>
        </PopupSubheader>
        {currentStep === 0 && (
          <ReportStepOne
            reportReasons={REPORT_REASONS}
            reportReason={reportReason}
            setReportReason={setReportReason}
            nextStep={nextStep}
          />
        )}
        {currentStep === 1 && (
          <ReportStepTwo
            comment={reportMessage}
            onChangeComment={handleReportMessage}
            isCanContact={isCanContact}
            handleIsCanContact={handleIsCanContact}
            report={report}
          />
        )}
      </Paper>
    </Backdrop>
  );
};

export default ReportPopup;

const PopupSubheader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& h3": {
    color: "black !important",
    fontSize: "20px",
    fontWeight: "500",
  },
  "& button": {
    padding: "6px 0",
    minWidth: "32px",
  },
  "& img": {
    width: "32px",
    height: "32px",
  },
});
